export default __webpack_public_path__ + "static/media/docs-icon.66037cc9.svg";